import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  defaultFont,
} from "assets/jss/material-dashboard-react.js";

const tableStyle = (theme) => ({
  warningTableHeader: {
    color: warningColor[0],
  },
  closeButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    background: '#fff',
    marginLeft: 'auto'
  },
  closeButton: {
    minWidth: 'unset',
    padding: '0px'
  },
  tableCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'space-between',
    textAlign: 'center',
    background: `${primaryColor[0]} !important`,
    fontWeight: 'bold',
    fontSize: '18px',
  },
  primaryTableHeader: {
    color: primaryColor[0],
  },
  dangerTableHeader: {
    color: dangerColor[0],
  },
  successTableHeader: {
    color: successColor[0],
  },
  infoTableHeader: {
    color: infoColor[0],
  },
  roseTableHeader: {
    color: roseColor[0],
  },
  grayTableHeader: {
    color: grayColor[0],
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse",
  },
  tableHeadCell: {
    color: "inherit",
    ...defaultFont,
    "&, &$tableCell": {
      fontSize: "15px",
      fontWeight: 'bold'
    },
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "0px",
    verticalAlign: "middle",
    fontSize: "0.8125rem",
    fontWeight: 'bold',
    color: '#555',
    '@media (max-width: 950px)' : {
      fontSize: "10px !important",
      '& .d-flex': {
        alignItems: 'center',
        '& > div:not(:first-child)': {
          width: '20px!important',
          height: '20px!important',
          backgroundSize: '20px auto'
        }
      }
     }
  },
  cellTextCenter: {
    textAlign: 'center',
    '& div[class*="-container"]': {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  tableResponsive: {
    width: "100%",
  },
  tableHeadRow: {
    height: "56px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle",
  },
  tableBodyRow: {
    height: "48px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle",
  },
  selected: {
    background: '#dbdcde !important'
  },
  clickable: {
    cursor: 'pointer' 
  }
});

export default tableStyle;
